import { useSetAtom } from 'jotai'
import * as R from 'ramda'
import React, { useEffect, useRef } from 'react'

import { setResponseTapNumberAtom , MAIN_RESPONSE_TAP_KEY } from '../../services/response-tap/response-tap-atoms'

const getMutatedNodeData = (mutationRecordsList: MutationRecord[]) =>
  R.path(['0', 'addedNodes', '0', 'data'])(mutationRecordsList)

const ResponseTap = () => {
  const setResponseTapNumber = useSetAtom(setResponseTapNumberAtom)
  const mainNumberSpanEl = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new MutationObserver((e) => {
      const callNumber = getMutatedNodeData(e) as string
      setResponseTapNumber({ [MAIN_RESPONSE_TAP_KEY]: callNumber })
    })
    observer.observe(mainNumberSpanEl.current!, { childList: true })
  }, [setResponseTapNumber])

  return (
    <>
      <div
        style={{
          width: '1px',
          height: '1px',
          overflow: 'hidden',
        }}
        ref={mainNumberSpanEl}
        className={MAIN_RESPONSE_TAP_KEY}
      />
      {/* here could be other spans with other keys*/}
    </>
  )
}

export default ResponseTap
